/* eslint-disable no-underscore-dangle */
import type { API } from 'chessboard/api/config/types';
import type { Game } from 'chessboard/model/game/types';
import { getLineDiff } from 'api/model/get-line-diff';
import { getPlyDiff } from 'api/model/get-ply-diff';
import { extendMove } from 'chessboard/model/move/extend-move';

/**
 * Create the getNodeDiffData method.
 */
export function createGetNodeDiffData(context: API.Context) {
  /**
   * Gets data about the difference between two nodes.
   * If the nodes are adjacent, it returns a 'move' (i.e. a forwards OR backwards move).
   * If the nodes are non-adjacent, it returns a `pieces` object so that the new position
   * can be reconstructed.
   */
  return function getNodeDiffData(
    before?: Game.Move.ExtendedNode,
    after?: Game.Move.ExtendedNode,
  ): API.DiffData {
    const { api, game } = context;

    const afterMove = after ?? game._getPos();
    const beforeMove = before ?? game._getPos(-1, 0);

    const data: any = {};

    data.plyDiff = getPlyDiff(beforeMove, afterMove);
    data.lineDiff = getLineDiff(beforeMove, afterMove);

    if (data.plyDiff === -1) {
      data.move = extendMove(<Game.Move.Node>{ ...before, animate: true });
    } else if (data.plyDiff === 1) {
      data.animate = true;
      data.move = extendMove(<Game.Move.Node>{ ...afterMove, animate: true });
    } else {
      data.pieces = api.getPieces();
    }

    return data;
  };
}
